import React from "react";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { CardListItem } from "src/app/components/ContentElements/CardListItem/CardListItem";
import iconsMap from "src/assets/iconsMap";
import Button from "src/app/components/ContentElements/Button/Button";
import ProgressBar from "src/app/components/ProgressBar/ProgressBar";
import FixedErrorBox from "src/app/components/FixedErrorBox/FixedErrorBox";
import styles from "./FaqList.module.css";
import useFaqProvider from "src/app/hooks/useFaqProvider";

const FaqList = (state) => {
  const {
    faqs,
    currentPage,
    prevButtonIsActive,
    nextButtonIsActive,
    onPreviousButtonClick,
    onNextButtonClick,
    itemToFocus,
    loading,
    fixedErrorVisible,
    failedDirection,
  } = useFaqProvider(state);

  const {
    baseUrl = "",
    errorContent = {},
    faqListCopy: {
      loadPrevious = "",
      loadMore = "",
      numberText = "",
      viewedText = "",
    } = {},
    itemCount: faqTotal = "0",
    pageSize,
  } = state;

  const icon = iconsMap("Related Article");

  const nextButton = {
    text: loadMore,
    link: {
      href: `?page=${currentPage + 2}`,
      target: null,
    },
    dataPage: currentPage + 1,
    target: null,
  };

  const prevButton = {
    text: loadPrevious,
    link: {
      href: currentPage < 1 ? `.` : `?page=${currentPage}`,
      target: null,
    },
    dataPage: currentPage + 1,
    target: null,
  };

  return (
    <>
      <h2 className={styles.foundFaqs} role="presentation">
        {numberText.replace("<x>", faqTotal)}
      </h2>
      {prevButtonIsActive && (
        <div className={styles.buttonContainer}>
          <Button
            data={prevButton}
            role="button"
            onClick={onPreviousButtonClick}
            loading={loading}
          />
        </div>
      )}
      <ul>
        <TransitionGroup component={null}>
          {faqs.length > 0 &&
            faqs.map((item, i) => {
              const link = baseUrl ? `${baseUrl}${item.href}` : item.href; // we need to do this to append for instance /ru/ in front of the faq urls

              return (
                <CSSTransition
                  key={`${item.text}-${i}`}
                  timeout={500}
                  classNames="global_item"
                >
                  <CardListItem
                    key={item.title}
                    link={link}
                    iconPosition="right"
                    icon={icon}
                    ariaPosInSet={i + 1}
                    ariaSetSize={faqs.length}
                    isFocused={itemToFocus === i}
                    text={item.title}
                  />
                </CSSTransition>
              );
            })}
        </TransitionGroup>
      </ul>
      <ProgressBar
        viewedText={viewedText}
        totalItems={faqTotal}
        totalVisibleItems={
          pageSize * (currentPage + 1) < faqTotal
            ? pageSize * (currentPage + 1)
            : faqTotal
        }
      />
      {nextButtonIsActive && (
        <div className={styles.buttonContainer}>
          <Button
            data={nextButton}
            role="button"
            onClick={onNextButtonClick}
            loading={loading}
          />
        </div>
      )}
      <FixedErrorBox
        visible={fixedErrorVisible}
        header={errorContent?.clientSearchErrorTitle}
        description={errorContent?.clientSearchErrorDescription}
        onClick={
          failedDirection === "prev" ? onPreviousButtonClick : onNextButtonClick
        }
      />
    </>
  );
};

export default FaqList;

FaqList.propTypes = {
  analytics: PropTypes.object.isRequired,
  baseUrl: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  errorContent: PropTypes.object.isRequired,
  faqID: PropTypes.string.isRequired,
  faqListCopy: PropTypes.object.isRequired,
  header: PropTypes.object,
  items: PropTypes.array.isRequired,
  itemCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
  storeData: PropTypes.object.isRequired,
};
